/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { Byte } from './byte.schema';

export const ArrayOfByte = zod.array(zod.lazy(() => Byte));

export type ArrayOfByte = zod.input<typeof ArrayOfByte>;
export type ArrayOfByteOutput = zod.output<typeof ArrayOfByte>;
